export default __webpack_public_path__ + "static/media/me13.2c6974ec.gif";